import { render, staticRenderFns } from "./groupsList.vue?vue&type=template&id=3987bce1&"
import script from "./groupsList.vue?vue&type=script&lang=js&"
export * from "./groupsList.vue?vue&type=script&lang=js&"
import style0 from "./groupsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports